import React, { useEffect } from "react";
import { Scrollbars } from "react-custom-scrollbars-4";
import { useSnackbar } from "notistack";
import {
  Link,
  CircularProgress,
  Backdrop,
  Container,
  Stack,
  Breadcrumbs,
  Toolbar,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ChecklistsList from "./ChecklistsList";
import { getProject } from "../helpers/getProject";

export default function Checklists(props) {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = React.useState(true);
  const [isReady, setIsReady] = React.useState(false);
  const [project, setProject] = React.useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const params = window.location.href.split("/");
        const proj = await getProject(params[params.length - 2]);
        setProject(proj);
      } catch (error) {
        console.error("Error getting project:", error);
        enqueueSnackbar(error.message, {
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
          variant: "error",
        });
      } finally {
        setIsLoading(false);
      }
    };

    if (isLoading === true && isReady === false) {
      setIsReady(true);
      fetchData();
    }
  }); 

  const passIsLoading = (bool) => {
    setIsLoading(bool);
  };

  return isLoading ? (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  ) : (
    <Scrollbars
      autoHide
      autoHideTimeout={10}
      style={{ width: "100%", height: "100%" }}
    >
      <Toolbar />
      <Container
        maxWidth="xl"
        style={{
          // paddingTop: 30,
          paddingBottom: 30,
          // paddingBottom: theme.spacing(4),
          justifyContent: "center",
        }}
      >
        <Typography
          color="primary.light"
          style={{ paddingTop: 40 }}
          variant="h5"
          gutterBottom
        >
          Checklists
        </Typography>

        <Stack
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
          spacing={2}
        >
          <Breadcrumbs separator="›" aria-label="breadcrumb">
            <Link
              underline="hover"
              key="1"
              color="inherit"
              href=""
              onClick={() =>
                navigate(`/project/${project.id}/dashboard`, {
                  state: { passProject: project },
                })
              }
            >
              Project: {project.Name}
            </Link>
            ,
            <Typography
              underline="hover"
              key="2"
              color="inherit"
              href={`/project/${project.id}/Checklists`}

              // onClick={handleClick}
            >
              {`Checklists (${project.Checklists.length})`}
            </Typography>
            ,
          </Breadcrumbs>
        </Stack>
        {project !== null && (
          <ChecklistsList
            user={props.user}
            project={project}
            observationId={null}
            equipmentId={null}
            passIsLoading={passIsLoading}
            saveCurrentProject={props.saveCurrentProject}
          />
        )}
      </Container>
    </Scrollbars>
  );
}
